import script from "./DownLoadSearch.vue?vue&type=script&setup=true&lang=ts"
export * from "./DownLoadSearch.vue?vue&type=script&setup=true&lang=ts"

import "./DownLoadSearch.vue?vue&type=style&index=0&id=502b1a6b&lang=scss&scoped=true"

import exportComponent from "/home/matriXagent/git/center-secure/product/ap/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-502b1a6b"]])

export default __exports__